(ns renolit-roofing-service.layout.session)

(defn layout
  [inner-comp]
  [:div.session
   [:div.session_main
    [:div.session_main-title-container
     [:h1 "RENOLIT"]
     [:h3 "Roofing"]]
    inner-comp]
   [:div.session_lateral-image]])